import { Collection } from '@/kernel/collection';

import StringCell from '@/components/cells/string-cell.vue';
import DateCell from '@/components/cells/date-cell.vue';
import BooleanCell from '@/components/cells/boolean-cell.vue';
import EditCollectionCell from '@/components/cells/edit-collection-cell.vue';

import { DateRangeFilterAdapter, SelectFilterAdapter, MultipleRelationInputAdapter } from '@/kernel/adapters';

import DateRangeInput from '@/components/inputs/date-range-input.vue';
import TextInput from '@/components/inputs/text-input.vue';
import CheckboxInput from '@/components/inputs/checkbox-input.vue';
import SelectInput from '@/components/inputs/select-input.vue';
import MultipleRelationInput from '@/components/inputs/multiple-relation-input.vue';

const isSuspendedOptions = [
  {value: null, label: 'Any'},
  {value: false, label: 'Active'},
  {value: true, label: 'Suspended'}
];

const isSelfServiceOptions = [
  {value: null, label: 'Any'},
  {value: false, label: 'Is not self service'},
  {value: true, label: 'Is self service'}
];

export class Organisation extends Collection {
  config = {
    autoRoute: true,
    requiresSuperAdmin: true,
    key: 'organisation',
    pluralLabel: 'Organisations',
    singleLabel: 'Organisation',
    indexUrl: '/organisation',
    createUrl: '/organisation/create',
    searchKeys: ['name'],
    editUrlPrefix: '/organisation',
    idKey: 'id',
    nameKey: 'name',
    payloadEndpoint: '/organisation',
    defaultSort: {
      key: 'name',
      order: 1
    },
    indexColumns: [
      {name: 'Actions', key: 'edit', sortable: false, cell: EditCollectionCell, props: {collection: 'organisation'}},
      {name: 'Name', key: 'name', sortable: true, cell: StringCell},
      {name: 'Is Suspended', key: 'isSuspended', sortable: false, cell: BooleanCell},
      {name: 'Is Self Service', key: 'isSelfService', sortable: false, cell: BooleanCell},
      {name: 'Updated', key: 'updatedAt', sortable: true, cell: DateCell},
      {name: 'Created', key: 'createdAt', sortable: true, cell: DateCell}
    ],
    indexFilters: [
      {key: 'isSuspended', label: 'Is Suspended', input: SelectInput, adapter: SelectFilterAdapter, props: {label: 'Is Suspended', options: isSuspendedOptions}},
      {key: 'isSelfService', label: 'Is Self Service', input: SelectInput, adapter: SelectFilterAdapter, props: {label: 'Is Self Service', options: isSelfServiceOptions}},
      {key: 'updatedAt', label: 'Updated at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Updated at'}},
      {key: 'createdAt', label: 'Created at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Created at'}}
    ],
    createFormFields: [
      {key: 'isSuspended', label: 'Is Suspended', input: CheckboxInput, props: {label: 'Is Suspended'}},
      {key: 'isSelfService', label: 'Is Self Service', input: CheckboxInput, props: {label: 'Is Self Service'}},
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'enabledThemes', label: 'Themes', input: MultipleRelationInput, adapter: MultipleRelationInputAdapter('theme'), props: {label: 'Themes', collection: 'theme'}}
    ],
    editFormFields: [
      {key: 'isSuspended', label: 'Is Suspended', input: CheckboxInput, props: {label: 'Is Suspended'}},
      {key: 'isSelfService', label: 'Is Self Service', input: CheckboxInput, props: {label: 'Is Self Service'}},
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'enabledThemes', label: 'Themes', input: MultipleRelationInput, adapter: MultipleRelationInputAdapter('theme'), props: {label: 'Themes', collection: 'theme'}}
    ]
  }
}